import {Component, Input} from "@angular/core";
import {UploadFormConfig} from "../upload-form-config";
import {environment} from "../../../../environments/environment";

@Component({
    selector: "app-holter-ecg-upload-form",
    templateUrl: "./holter-ecg-upload-form.component.html",
    standalone: false
})
export class HolterEcgUploadFormComponent {
  private _formConfig?: UploadFormConfig;
  isEForm = environment.eforms;

  @Input() showPostMeasurementFields!: boolean;
  @Input() showPreMeasurementFields!: boolean;
  @Input() ecgTechnicianAnalysisOnlyEnabled!: boolean;
  @Input() isHome!: boolean;

  @Input()
  set formConfig(formConfig: UploadFormConfig) {
    this._formConfig = formConfig;
  }

  get formConfig(): UploadFormConfig {
    return this._formConfig!;
  }
}
